import React from "react";
import {
    SovosDialog,
    SovosButton,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
} from "mosaic-react";

const buildText = (text) => {
    if (Array.isArray(text)) {
        return (
            <ul>
                {text.map((val, index) => (
                    <li key={index}>
                        <small>{val}</small>
                    </li>
                ))}
            </ul>
        );
    }

    return text ? <small>{text}</small> : <></>;
};
const ConfirmDialog = (props) => {
    const { data, confirm, cancel, i18n } = props;
    const { title, text, promptText, confirmText = "" } = data;

    return (
        <SovosDialog open={true}>
            <SovosDialogTitle
                showCloseButton
                onClose={() => {
                    cancel && cancel();
                }}
            >
                {title}
            </SovosDialogTitle>
            <SovosDialogContent>
                {buildText(text)} {promptText}
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton
                    variant="text"
                    onClick={() => {
                        cancel && cancel();
                    }}
                >
                    {i18n`Cancel`}
                </SovosButton>
                <SovosButton
                    onClick={() => {
                        confirm && confirm();
                    }}
                >
                    {confirmText ? confirmText : i18n`Confirm`}
                </SovosButton>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export default ConfirmDialog;
